<template>
  <div class="h-100 d-flex justify-content-center align-items-center">
    <div class="loader">
      <div class="ball-spin-fade-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoaderApp"
};
</script>